export const logoDarkTheme = require('./logo-dark-theme.png')
export const logoLightTheme = require('./logo-light-theme.png')
export const logoDarkSmall = require('./tait-logo-white.png')
export const logoLightSmall = require('./tait-logo-black.png')
export const adminName = require('./admin_name.png')
export const bgLogin = require('./login-bg.png')
export const groupImage = require('./group-img.png')
